<template>
  <div class="w-full flex aiSuggestDialogue">
    <div class="chat-content-quote flex align-items-start flex-1 lg:w-auto">
      <div class="chat-content-quote-text p-3 results_en order-1 flex-1" @click.prevent="copy_text_selection(replySuggestions)">
        <div class="en results_en">
          <!-- <p v-if="!isLoadingReplySuggest" class="m-0 p-0"><span class="m-0 p-0 cursor-pointer" v-for="(item, index) in sentenceSpliter" :key="index" :class="{ 'active': dictIdx === index, 'pointer isDictionary': isDictionary && !isRegular(item) }" @click.stop="setIdxEn(item, index)">{{ item }}<WordDict v-click-outside="onClickOutside" class="hidden lg:block dict_chat" v-if="dictIdx === index" v-on:closeDict="closeDict" :content="ductWord"/></span></p> -->
          <p v-if="!isLoadingReplySuggest" class="m-0 p-0">{{ replySuggestions }}</p>
          <div v-if="isLoadingReplySuggest"><img src="@/assets/image/ai/loading.gif" alt=""></div>
        </div>

        <div class="zh results_zh">
          <p class="m-0 p-0 tips-suggestion mt-2 pt-2" v-if="isTranslate && translate && !isLoadingTranslate">{{ translate }}</p>
          <div v-if="isLoadingTranslate" class="tips-suggestion mt-2 pt-2"><img src="@/assets/image/ai/loading.gif" alt=""></div>
        </div>
      </div>
      <div class="robot-btns flex flex-col xl:flex-row items-center xl:items-start mx-2 justify-end order-2 my-1 md:my-0">
        <a class="tooltip-outer flex justify-center items-center m-1 cursor-pointer">
          <div class="relative" v-if="!ttsUrl && isLoadingTTS">
            <img src="@/assets/image/ai/btn_AItalk_play_loading_circle.png">
            <img src="@/assets/image/ai/loading_circle.png" class="absolute loading_circle">
          </div>
          <img src="@/assets/image/ai/btn_AItalk_play_dark.png" v-if="ttsUrl && isPlayingAudio" @click="audio_stop()">
          <img src="@/assets/image/ai/btn_AItalk_play_perple.png" v-if="(ttsUrl && !isPlayingAudio) || (!ttsUrl && !isLoadingTTS)" @click="toggleTTS()">
          <span class="tooltiptext">{{ $t('hover.play') }}</span>
        </a>
        <a class="tooltip-outer flex justify-center items-center m-1 cursor-pointer font-variant-east-asian-traditional" @click="toggleTranslate()">
          <img src="@/assets/image/ai/btn_AItalk_CN_perple.png" v-if="!isTranslate && $route.name === 'ChatAI'" >
          <img src="@/assets/image/ai/btn_AItalk_CN_active_perple.png" v-if="isTranslate && $route.name === 'ChatAI'">

          <img src="@/assets/image/ai/btn_AItalk_CN_perple_jp.png" v-if="!isTranslate && $route.name !== 'ChatAI'">
          <img src="@/assets/image/ai/btn_AItalk_CN_active_perple_jp.png" v-if="isTranslate && $route.name !== 'ChatAI'">
          <span class="tooltiptext">{{ $t('hover.translate') }}</span>
        </a>
        <a class="tooltip-outer flex justify-center items-center cursor-pointer m-1" @click="retrieveData()">
          <img src="@/assets/image/ai/btn_AItalk_Re.png">
          <span class="tooltiptext">{{ $t('hover.refresh') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import dictApi from '@/dictApi'
// import WordDict from '@/components/AiHelper/WordDict'
import allJs from '@/components/all.js'
import Bus from '@/components/bus.js'
export default {
  name: 'aiSuggestDialogue',
  props: {
    session_id: {
      type: String
    },
    lastChatResult: {
      type: String
    },
    theme: {
      type: String
    },
    context: {
      type: String
    },
    context2: {
      type: String
    },
    recordArray: {
      type: Object
    }
  },
  mixins: [
    allJs
  ],
  components: {
    // WordDict
  },
  data () {
    return {
      ttsUrl: null,
      translate: null,

      isDictionary: true,
      isTranslate: false,

      ductWord: null,
      dictIdx: -1,

      replySuggestions: null,

      sound_effect: null,

      // status
      isLoadingReplySuggest: false,
      isLoadingTranslate: false,
      isLoadingTTS: false,
      isPlayingAudio: false
    }
  },
  watch: {
    'playbackRate': {
      handler (newVal, oldVal) {
        let self = this
        if (newVal !== oldVal) {
          self.audio_setRate()
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'playbackRate'
    ])
    // sentenceSpliter () {
    //   let self = this
    //   if (self.replySuggestions) {
    //     const str = self.replySuggestions
    //     let pattern = /([\n\s\p{P}])/u
    //     const splitStr = str.split(pattern)
    //     return splitStr
    //   }
    //   return []
    // }
  },
  mounted () {
    !this.replySuggestions ? this.reply_suggestions() : null

    Bus.$on('stopPlay', () => {
      this.isPlayingAudio ? this.audio_stop() : null
    })
  },
  methods: {
    onClickOutside () {
      this.closeDict()
    },

    async reply_suggestions () {
      // AI代答
      let self = this
      let prompt_id = '837b6b5e-00eb-47a7-b280-a3119e8394c1'

      if (self.$route.name === 'ChatAIJp') {
        prompt_id = '69752778-923c-4b7e-ad50-fdc4dd7c3029'
      }

      let path = `/ai/generate/${prompt_id}`

      self.isLoadingReplySuggest = true

      self.ttsUrl = null
      self.translate = null

      await api.post(path, {
        // content: self.lastChatResult, 4/12 leo說要拿掉
        content: '',
        theme: self.theme,
        context: self.context,
        context2: self.context2,
        session: self.session_id
      })
      .then((res) => {
        self.replySuggestions = res.data.result

        self.isLoadingReplySuggest = false
      })
      .catch(() => {
        self.isLoadingReplySuggest = false

        self.$swal({
          html: `<p>請重新操作</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: `我知道了`,
          title: 'Notice',
          customClass: {
            title: 'text-white',
            container: '',
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            closeButton: '',
            htmlContainer: 'remainPoints_swal my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      })
    },

    closeDict () {
      let self = this
      self.ductWord = null
      self.dictIdx = -1

      Bus.$emit('getDickData', { dictIdx: idx, ductWord: data.data})
    },

    async setIdxEn (item, idx) {
      let self = this
      if (self.isDictionary && !self.isRegular(item)) {
        const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${item}`)
        self.dictIdx = idx
        self.ductWord = data.data

        Bus.$emit('getDickData', { dictIdx: idx, ductWord: data.data})
      }
    },

    isRegular (val) {
      // eslint-disable-next-line no-useless-escape
      let pattern = new RegExp(/[\p{P}\s]/u)
      if (val && val.match(pattern)) {
        return true
      }
      return false
    },

    retrieveData () {
      let self = this
      self.translate = null
      self.ttsUrl = null
      self.isTranslate = false

      self.reply_suggestions()
    },

    async toggleTranslate () {
      let self = this
      self.isTranslate = !self.isTranslate

      if (!self.translate) {
        self.isLoadingTranslate = true
        self.translate = await self.get_Translate_Dialog(self.theme, self.context, self.replySuggestions)
      }

      if (self.translate) {
        self.isLoadingTranslate = false
      }
    },

    async toggleTTS () {
      let self = this

      if (!self.ttsUrl) {
        const myName1 = () => {
          return new Promise(async(resolve) => {
            self.isLoadingTTS = true
            self.ttsUrl = await self.getTTSUrl('female', self.replySuggestions)
            if (self.ttsUrl) {
              resolve('Ray1')
            }
          })
        }

        Promise.race([myName1()])
        .then(() => {
          self.sound_effect = new Audio(self.ttsUrl)
        })
        .then(() => {
          self.sound_effect.playbackRate = self.playbackRate
          self.audio_play()
          self.isLoadingTTS = false
        })
        .then(() => {
          self.audio_play()
        })
      } else {
        self.audio_play()
      }
    },

    audio_play () {
      let self = this
      self.isPlayingAudio = true
      self.sound_effect.play()
      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()
      })
    },
    audio_stop () {
      let self = this
      self.isPlayingAudio = false
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
    },
    audio_setRate () {
      let self = this
      self.sound_effect ? self.sound_effect.playbackRate = self.playbackRate : null
    }
  }
}
</script>
<style lang="scss" scoped>
  .aiSuggestDialogue {
    min-height: 152px;
  }
  .loading_circle {
    top: 15%;
    left: 15%;
    transform: translate(-50%, -50%);
    animation: spin 2s infinite linear;
    transform-origin: center;
  }
  @keyframes spin  {
    from {
      transform: rotate(0deg);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
  .results_en {
    p {
      white-space: pre-line;
      word-break: normal;
      margin-bottom: 0;
      span {
        position: relative;
      }
      .dict_chat {
        bottom: 100% !important;
        top: auto !important;
      }
      .isDictionary {
        &:hover {
          background-color: #BBDDFF;
        }
      }
      .active {
        background-color: #BBDDFF;
      }
    }
  }
  .chat-content-quote {
    max-width: 80%;
    @media (max-width: 1024px) {
      max-width: 100%;
    }
    .chat-content-quote-text {
      color: #5A5D9B;
      border: 1px solid #5A5D9B;
      border-bottom-left-radius: 20px 20px;
      border-bottom-right-radius: 20px 20px;
      border-top-right-radius: 20px 20px;
      .option-item {
        width: 25%;
        text-align: center;
      }
      .tips-suggestion {
        border-top: 1px solid #5A5D9B;
        border-style: dashed none none;
        color: #5A5D9B;
      }
    }
  }
</style>
